module.exports = __webpack_public_path__ + "img/编组 7@2x.516b91a0.png";